// extracted by mini-css-extract-plugin
module.exports = {"field-label":"field-label_field-label__1fumm","field-label--uppercase":"field-label_field-label--uppercase__tRDTM"};